"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var DropDown_1 = __importDefault(require("../../common/DropDown/DropDown"));
var icons_1 = __importDefault(require("../../theme/icons"));
var client_1 = require("@apollo/client");
var queries_1 = require("../LanguageSelector/Graphql/queries");
function RoleSelector(props) {
    var _a = (0, react_1.useState)([]), roles = _a[0], setRoles = _a[1];
    var _b = (0, client_1.useLazyQuery)(queries_1.GET_BACKEND_ROLES), callroles = _b[0], responseroles = _b[1];
    (0, react_1.useEffect)(function () {
        callroles();
    }, []);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if ((_a = responseroles === null || responseroles === void 0 ? void 0 : responseroles.data) === null || _a === void 0 ? void 0 : _a.getBackendRoles) {
            init((_b = responseroles === null || responseroles === void 0 ? void 0 : responseroles.data) === null || _b === void 0 ? void 0 : _b.getBackendRoles);
        }
    }, [responseroles]);
    function init(response) {
        return __awaiter(this, void 0, void 0, function () {
            var tmp;
            return __generator(this, function (_a) {
                tmp = [];
                response.map(function (l) {
                    var role_id = l.role_id, role_name = l.role_name;
                    tmp.push({
                        value: role_id,
                        label: role_name,
                    });
                });
                setRoles(tmp);
                return [2 /*return*/];
            });
        });
    }
    return (react_1.default.createElement("div", { style: {
            margin: '0.31rem 0',
            display: 'flex',
            flex: 1,
            width: '100%',
            flexDirection: 'column',
        } },
        props.error && react_1.default.createElement("p", { className: 'error' }, props.error),
        react_1.default.createElement(DropDown_1.default, { defaultValue: props.defaultValue, icon: react_1.default.createElement(icons_1.default, { className: 'icon_orange', height: 32, name: 'role', width: 32 }), name: 'role', onChange: props.onChange, options: roles, value: props.value })));
}
RoleSelector.propTypes = {
    error: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    style: prop_types_1.default.object,
    className: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    defaultValue: prop_types_1.default.any,
    value: prop_types_1.default.any,
};
exports.default = RoleSelector;
